export default "__VITE_ASSET__BZFlukA7__"